export default __webpack_public_path__ + "70f3dfbf7b76eca01695086b726e3b7f.jpeg";